module.exports = __webpack_public_path__ + "media/assets/icons/convo-305e7306e6af21f5c8899e1ffedae6ac.png";